import React from 'react';
import {
  CardSection,
  CompanyLogo,
  Flashy,
  Layout,
  LayoutItem,
  LogoUtil,
  ParagraphHeader,
  SmallHeader,
  useBreakpoint,
} from '@axiom/ui';
import type { CardSectionBackgrounds } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

export type EngagementHeaderProps = {
  appendRight?: React.ReactNode;
  background?: CardSectionBackgrounds;
  divider?: boolean;
  engagement: CandidateEngagementDetails;
  name?: string;
  textReversed?: boolean;
};

export const EngagementHeader: React.FC<EngagementHeaderProps> = ({
  appendRight,
  background,
  divider = false,
  engagement,
  name = 'ENGAGEMENT_HEADER',
  textReversed = false,
}) => {
  const { isSmallScreen } = useBreakpoint();
  return (
    <CardSection background={background} divider={divider} name={name}>
      <Layout
        name="OUTER_LAYOUT"
        position="middle space-between"
        horizontalGutter="16px"
      >
        {isSmallScreen || !engagement.opportunity.account ? null : (
          <LayoutItem>
            <CompanyLogo
              name="COMPANY_LOGO"
              alt={`${engagement.opportunity.accountName} logo`}
              src={LogoUtil.getUrl(engagement.opportunity.account.website)}
            />
          </LayoutItem>
        )}
        <LayoutItem fluid>
          <Layout
            name="INNER_LAYOUT"
            position={isSmallScreen ? 'left' : 'middle space-between'}
            stackableOn="smallScreen"
            verticalGutter="16px"
          >
            <LayoutItem name="ENGAGEMENT_INFO" fluid>
              <Flashy
                name="FLASHY"
                color={textReversed ? 'textReversed' : 'textDefault'}
              >
                <SmallHeader name="JOB_NAME">
                  {engagement.opportunity.jobName}
                </SmallHeader>
                <ParagraphHeader name="ACCOUNT_NAME">
                  {engagement.opportunity.accountName}
                </ParagraphHeader>
              </Flashy>
            </LayoutItem>
            {appendRight ? (
              <LayoutItem name="APPEND_RIGHT">{appendRight}</LayoutItem>
            ) : null}
          </Layout>
        </LayoutItem>
      </Layout>
    </CardSection>
  );
};
